import React, { useState, useEffect } from "react";
import { getAccessTokenApi } from "../../../api/auth";
import NoAvatar from "../../../assets/img/png/no-avatar.png";
import { get } from "../../../api/get";
import {
  Switch,
  List,
  Avatar,
  Button,
  Modal as ModalAntd,
  notification,
} from "antd";
import Modal from "../../../components/Modal";
import EditUserForm from "../../../components/Admin/Users/EditUserForm";

import "./Profile.scss";

export default function Profile() {
  const [user, setuser] = useState([]); 
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [reloadUsers, setReloadUsers] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState(null);

  function editUser(user){
    setIsVisibleModal(true);
    setModalTitle(
      `Edit ${user.name ? user.name : "..."} ${
        user.lastname ? user.lastname : "..."
      }`
    );
    setModalContent(
      <EditUserForm
        user={user}
        setIsVisibleModal={setIsVisibleModal}
        setReloadUsers={setReloadUsers}
      />
    );
  };

  useEffect(() => {
    get('user','user','').then((response)=>{
      // console.log('response:')
      // console.log(response.user)
      setuser(response.user)
      setuser(response.user)
    })
  }, [reloadUsers, setReloadUsers]); //Solo se refresca si cambian estos

  return (
      <div style={{display:'flex',flexDirection:'column',justifyItems:'center',marginTop:'20px',padding:'30px 30px 30px 30px',border: '5px solid rgb(203,234,247)'}}>
        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>

          <Avatar shape="square" src={user.avatar!==undefined ? (user.avatar.length>3)?user.avatar:NoAvatar : NoAvatar} style={{borderRadius: '15px',border: '3px solid rgb(0,104,178)'}} size={250}/>
          <div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Name:&nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}>{user.name} {user.lastname}</p>
            </div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Email:&nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}>{user.email}</p>
            </div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Role:&nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}>{user.role}</p>
            </div>
          </div>
          <div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Hubs in platform:&nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}> {(user.hubs)?user.hubs.length:'0'}</p>              
            </div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Vehicles in platform: &nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}>{(user.vehicles)?user.vehicles.length:'0'}</p>              
            </div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Workers in platform:&nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}>{(user.workers)?user.workers.length:'0'}</p>             
            </div>
            <div style={{display:'flex',flexDirection:'row'}}>
              <p style={{fontFamily:'report-bold',fontSize:'25px'}}>Inventory in platform:&nbsp;&nbsp;</p>
              <p style={{fontFamily:'report',fontSize:'25px'}}>{(user.inventory)?user.inventory.length:'0'}</p>              
            </div>
          </div>
        </div>
        <div style={{marginTop:'30px',display:'flex',flexDirection:'row',justifyContent:'center'}}>
          <Button type="primary" style={{
            backgroundColor:'white',
            borderWidth:'2px',
            width:'250px',
            fontSize:'15px',
            color:'rgb(35,148,212)',
            fontFamily:'report-bold',
          }} onClick={()=>editUser(user)}>
            Edit Profile
          </Button>
        </div>
        <Modal
          title={modalTitle}
          isVisible={isVisibleModal}
          setIsVisible={setIsVisibleModal}
        >
          {modalContent}
        </Modal> 
      </div> 
  );
}
